import React from 'react';

const Research = () => {
  return (
    <div>
      <div className="section" id="research">
        <h2>Books & Research</h2>
      </div>

      <div className="list-container-long" id="research">
        <div className="list-section">
          <img src="/images/Outlive.png" alt="Outlive Cover" className="list-image" />
          <div className="text-content">
            <h3>Outlive: The Science and Art of Longevity</h3>
            <p>by Peter Attia MD and Bill Gifford | Mar 28, 2023</p>
          </div>
        </div>
      </div>

      <div className="section">
        <p>
          The following are key research notes taken while reading Outlive. This is listed for reference as information
          that was extracted during the process.
        </p>
        <h3>Cardiovascular Notes</h3>
        <ul>
          <li>Apolipoprotein B (ApoB): Essential marker to assess cardiovascular risk.</li>
          <li>
            Lipoprotein(a) [Lp(a)]: High Lp(a) levels are genetically determined and linked to increased heart disease
            risk; recommended testing.
          </li>
          <li>Low-Density Lipoprotein Cholesterol (LDL-C): Optimal range recommended at 10-20 mg/dL for minimal risk.</li>
          <li>
            Research Antisense Oligonucleotides (ASOs): Emerging therapy to lower lipoproteins (specifically ApoB and
            Lp(a)), potentially reducing cardiovascular risk. Research further for clinical use and efficacy.
          </li>
        </ul>
        <h3>Genetic Notes</h3>
        <ul>
          <li>APOE: Associated with lipid metabolism and Alzheimer's disease risk.</li>
          <li>CETP: Linked to HDL cholesterol and heart disease risk.</li>
          <li>APOC3: Affects triglyceride metabolism; lower levels may be beneficial.</li>
          <li>
            Testing Recommendation: Genetic testing for the above markers can provide insight into personal risk factors
            and guide individualized prevention strategies.
          </li>
        </ul>
        <h3>Bone and Muscle Health</h3>
        <ul>
          <li>
            Bone Mineral Density (BMD): Critical to monitor for bone health and osteoporosis risk, particularly as aging
            affects bone and muscle composition.
          </li>
          <li>Testing Recommendation: BMD testing advised for proactive assessment and monitoring.</li>
        </ul>
        <h3>Exercise Protocols</h3>
        <ul>
          <li>Aerobic Exercise: 4 times weekly for 45 minutes per session (Zone 2 Training).</li>
          <li>Intensity: Zone 2 (low-intensity, fat-burning) training for cardiovascular health and mitochondrial efficiency.</li>
          <li>Target Lactate Range: 1.7-2.0 mmol during Zone 2 training.</li>
          <li>Testing Tool: Lactate meter to ensure optimal lactate range for endurance benefits.</li>
          <li>
            VO₂ Max (Aerobic Capacity): Average 45-Year-Old: ~40 ml/kg/min, Elite Athlete 60+ ml/kg/min, Unfit Individual:
            20s ml/kg/min.
          </li>
          <li>Testing Recommendation: Regular VO₂ max testing to assess cardiovascular fitness and progress.</li>
        </ul>
        <h3>Protein Recommendations</h3>
        <ul>
          <li>Minimum Intake: 1.6 g/kg/day daily protein intake for muscle health.</li>
          <li>
            Higher Intake for Active Individuals: Up to 2.2 g/kg/day, provided normal kidney function, to support muscle
            mass and metabolic health.
          </li>
        </ul>
      </div>

      <div className="list-container-long">
        <div className="list-section">
          <img src="/images/Lifespan.png" alt="Lifespan Cover" className="list-image" />
          <div className="text-content">
            <h3>Lifespan: Why We Age - and Why We Don't Have To</h3>
            <p>by David A. Sinclair | Sep 30, 2019</p>
          </div>
        </div>
      </div>

      <div className="section">
        <p>
          The following are key research notes taken while reading Lifespan. This is listed for reference as information
          that was extracted during the process.
        </p>
        <h3>Vitality Notes</h3>
        <ul>
          <li>AMPK: Enzyme that regulates energy balance and is activated during caloric restriction and exercise.</li>
          <li>mTOR: Key regulator of cell growth and aging; inhibition is associated with longevity.</li>
          <li>
            NAD (Nicotinamide Adenine Dinucleotide): Essential molecule in cellular energy production and DNA repair;
            levels decline with age.
          </li>
          <li>
            Sirtuins (SIRT1 to SIRT7): Family of proteins that regulate cellular health, DNA repair, and metabolism.
            Activated by NAD+ and play a role in longevity.
          </li>
        </ul>
        <h3>Longevity Molecules Notes</h3>
        <ul>
          <li>Rapamycin: mTOR inhibitor known for its anti-aging effects.</li>
          <li>
            Metformin: Common diabetes drug with potential anti-aging benefits. Standard dose often 850 mg; further
            research suggested to understand effects on aging.
          </li>
          <li>
            Resveratrol: Antioxidant found in red wine; known for activating sirtuins but limited by poor solubility.
          </li>
          <li>
            NAD+ Precursors: NR (Nicotinamide Riboside) and NMN (Nicotinamide Mononucleotide): NMN is found in foods like
            avocado, broccoli, and cabbage; David Sinclair's data suggests NMN may protect DNA and improve cellular health.
          </li>
        </ul>
        </div> 
        
        <div className="list-container-long">
        <div className="list-section">
          <img src="/images/Agelater.png" alt="Agelater Cover" className="list-image" />
            <div className="text-content">
            <h3>Age Later: Health Span, Life Span, and the New Science of Longevity</h3>
            <p>by Nir Barzilai M.D. and Toni Robino | Jun 16, 2020</p>
            </div>
            </div>
        </div>

        <div className="section">
        <p>The following are key research notes taken while reading Age Later.  This is listed for reference as information that was extracted during the process.</p>
        <h3>Longevity Companies Notes</h3>
        <ul> 
          <li>CohBar Inc: Founder Nir Barzilai</li>
          <li>Life Biosciences: Founders Tristan Edwards and David Sinclair, PhD, AO</li>
          <li>Continuum Biosciences: A daughter company of Life Biosciences</li>
          <li>afar: American Federation for Aging Research</li>
        </ul>
        <h3>Important Food Notes</h3>
        <ul>
            <li>No red meat, poultry, or other meats (excluding fish)</li>
            <li>No dairy</li>
            <li>Limit sugar to less than 10 grams a day</li>
            <li>Limit eating time (no more than 12 hours)</li>
            <li>Limit meals (2x day with high fiber snack with fewer then 100 calories if above 25 BMI)</li>
            <li>Yes large amounts of vegetables</li>
            <li>Yes legumes including beans, lentils, garbanzos, peas</li>
            <li>Yes whole grains including pasta and bread, but less than 100 grams a day</li>
            <li>Yes fruits but only 1 or 2 a day (apple, etc. or 2 handfuls of berries)</li>
            <li>Yes olive oil (80 grams per day), however if you have neurodegenerative issues 50 mil letters per day</li>
            <li>Yes nuts (30 grams a day of walnuts, almonds or hazelnuts)</li>
        </ul>
        <h3>Protein and BMI Recommendations</h3>
        <ul>
            <li>Protein should be between .31 to .36 grams per pound of body weight per day and suggested to consume most in one meal</li>
            <li>BMI is healthy in 22 to 23 range, however when age 65 go to 23 to 25 range</li>
        </ul>
      </div>  

      <div className="list-container-long">
        <div className="list-section">
          <a href="https://a.co/d/iMolZst" target="_blank">
          <img src="images/Longevitydiet.png" alt="Longevity Cover" className="list-image" />
          </a>
            <div className="text-content">
            <h3>The Longevity Diet: Slow Aging, Fight Disease, Optimize Weight</h3>
            <p>by Valter Longo | Dec 31, 2019</p>
            </div>
        </div>
      </div>   
      <div className="section">  
      <p>The following are key research notes taken while reading The Longevity Diet.  This is listed for reference as information that was extracted during the process.</p>
      <h3>Protein Recommendations</h3>
      <ul>
          <li>Protein should be between .31 to .36 grams per pound of body weight per day</li>
          <li>Protein should be free of animal proteins (diet should be mostly fish protein)</li>
          <li>75% of protein consumed in one meal</li>
      </ul>
      <h3>Products and Contributions</h3>
      <ul>
        <li>Creator of the Fasting Mimicking Diet</li>
        <li><a href="https://prolonlife.com" target="_blank" className="custom-link" rel="noopener noreferrer">Prolon</a> diet is based on research led by Dr. Valter Longo</li>
      </ul>
      </div>  

      <div className="list-container-long">
        <div className="list-section">
          <a href="https://a.co/d/3mVfwyG" target="_blank">
          <img src="images/Aging.png" alt="Aging Cover" className="list-image" />
          </a>
            <div className="text-content">
            <h3>Aging Cause : Cause & Cure Third Edition</h3>
            <p>by Dr. Gerald E Aardsma | Jan 1, 2023</p>
            </div>
        </div>
      </div>   
      <div className="section">  
      <p>The following are key research notes taken while reading The Aging Cause.  This is listed for reference as information that was extracted during the process.</p>
      <h3>Human Lifespans</h3>
      <p>The author sites the Bible as references for most of these dates.  This is a shorter list then what is in the book.</p>
      <div style={{ maxWidth: "500px", textAlign: "left", paddingLeft: "20px"  }}>
      <div className="ai-prompt-table">
      <div className="table-header">
        <div className="table-title">Name</div>
        <div className="table-title">Date</div>
        <div className="table-title">Lifespan</div>
      </div>
      {[
        { name: "Adam", date: "5176 B.C.", lifespan: "930 Years" },
        { name: "Seth", date: "5046 B.C.", lifespan: "912 Years" },
        { name: "Methuselah", date: "4489 B.C.", lifespan: "969 Years" },
        { name: "Noah", date: "4120 B.C.", lifespan: "950 Years" },
        { name: "Shem", date: "3617 B.C.", lifespan: "600 Years" },
        { name: "Arpachshad", date: "3517 B.C.", lifespan: "438 Years" },
        { name: "The Flood", date: "3520 B.C", lifespan: "Lasted 1 Year" },
        { name: "Peleg", date: "3418 B.C.", lifespan: "239 Years" },
        { name: "Abraham", date: "3167 B.C.", lifespan: "175 Years" },
        { name: "Joseph", date: "2916 B.C.", lifespan: "110 Years" },
        { name: "Moses", date: "2527 B.C.", lifespan: "120 Years" },
      ].map((item, index) => (
        <div className="table-row" key={index}>
          <div className="table-title">{item.name}</div>
          <div className="table-title">{item.date}</div>
          <div className="table-title">{item.lifespan}</div>
        </div>
      ))}
    </div>
    </div>

      <h3>Hypotheses and Theory</h3>
        <ul>
          <li><strong>Central Hypothesis: </strong>Modern human aging is a nutritional deficiency disease resulting from dietary insufficiency of one or more vitamins, previously unknown to science, made globally deficient by the impact of Noah's Flood on Earth's environment.</li>
          <li><strong>Vitamin MePiA Theory of Aging: </strong>MePiA is the antioxidant vitamin needed to complete Harman's free-radical theory of aging. MePiA has special access to the mitochondria. Dietary intake of MePiA regulates the rate of ROS damage to mitochondria, which regulates the rate of modern human aging.</li>
          <li><strong>Theory of Modern Human Aging: </strong>Modern human aging is a congenital nutritional deficiency disease of two newly discovered, closely related vitamins: methylphosphinic acid (MePiA) and methylphosphonic acid (MePA). Vitamin MePiA functions as an antioxidant within the mitochondria, protecting them from damage due to ROS. Vitamin MePA functions as its own unique vitamin, separate from vitamin MePiA. It is involved in multiple biochemical pathways, similar to the members of the traditional vitamins.</li>
        </ul>
      
      </div>  
      <div className="list-container-long">
        <div className="list-section">
          <a href="https://a.co/d/fTIZ7lS" target="_blank">
          <img src="images/Youngforever.png" alt="Young Forever Cover" className="list-image" />
          </a>
            <div className="text-content">
            <h3>Young Forever: The secrets to living your longest, healthiest life</h3>
            <p>by Dr Mark Hyman | Feb 16, 2023</p>
            </div>
        </div>
      </div>   
      <div className="section">  
      <p>The following are key research notes taken while reading Young Forever.  This is listed for reference as information that was extracted during the process.</p>
      <h3>Human Lifespans</h3>
      <p>The author also mentions Madame jeanne Calment who died at 122 and that he has heard personal reports of sages and rishis who live well past 150 years.</p>
      <div style={{ maxWidth: "320px", textAlign: "left", paddingLeft: "20px"  }}>
      <div className="ai-prompt-table">
      <div className="table-header">
        <div className="table-title">Name</div>
        <div className="table-title">Lifespan</div>
      </div>
      {[
        { name: "Adam", lifespan: "930 Years" },
        { name: "Methuselah", lifespan: "969 Years" },
        { name: "Noah", lifespan: "950 Years" },


      ].map((item, index) => (
        <div className="table-row" key={index}>
          <div className="table-title">{item.name}</div>
          <div className="table-title">{item.lifespan}</div>
        </div>
      ))}
    </div>
    </div>
      
      <h3>Network Medicine</h3>
      <p>The body has 7 dynamically interconnected, networked system that underlie all disease (155,000 diseases)</p>
      <ul>
          <li>Assimilating nutrients, digestion, and the microbiome</li>
          <li>Defense and repair (immune and inflammatory)</li>
          <li>Energy production (mitochondria)</li>
          <li>Detoxification</li>
          <li>Transportation (circulation and lymphatic)</li>
          <li>Communication (hormones, neurotransmitters, etc)</li>
          <li>Body Structure (cellular to musculoskeletal)</li>
      </ul>
      <h3>Protein Recommendations</h3>
      <ul>
          <li>The average person needs 25 to 40 grams of protein per meal</li>
          <li>The best timing of protein intake is within an hour or two after exercise</li>
          <li>The best protein for muscle synthesis is animal protein because it contains high levels of leucine and creatine</li>
      </ul>
      <h3>Testing</h3>
      <ul>
          <li>GGT (Gamma-glutamyl transpeptidase) can identify environmental toxin exposure and fatty liver</li>
      </ul>
    </div>  

    <div className="list-container-long">
        <div className="list-section">
          <img src="/images/Breath.png" alt="Breath Cover" className="list-image" />
          <div className="text-content">
            <h3>Breath: The New Science of a Lost Art</h3>
            <p>by James Nestor | May 26, 2020</p>
          </div>
        </div>
      </div>

      <div className="section">
        <p>
          The following are key research notes taken while reading Breath. This is listed for reference as information
          that was extracted during the process.
        </p>
        <h3>Key References</h3>
        <ul>
          <li>George Catlin Quote: He credited his longevity to the "great secret of life": to always breath through the nose.</li>
          <li>Dr. Mark Burhenne: Burhenned also found that mouth breathing was both a cause of and a contributor to snoring and sleep apnea.</li>
          <li>Swami Rama: Rama revealed secrets of prana control.  In his breathing technique he suggested upon reaching a specific count of 30 with this technique that his students will not have any toxins and will be disease-free.</li>
          <li>Carl Stough: The difference in breathing in the coordinated pattern and in an altered pattern is the difference between operating at peak efficiency and just getting along.</li>
        </ul>
        <h3>Breathing Methods</h3>
        <ul>
          <li>Alternative Nostril: The pranaymama technique improves lung function,lowers heart rate, blood pressure, and sympathetic stress.</li>
          <li>Resonant (Coherent): A calming practice that places heart, lungs, and circulation where the body works in peak efficiency.</li>
          <li>Tummo: There are two forms of Tummo (one for sympathetic and one for parasympathetic)  The former made popular by Wim Hof.</li>
          <li>Sudarshan Kriya: Consists of 4 phases (Om chants, breath restriction, paced breathing, and heavy breathing) and the most difficult.</li>
        </ul>
        <h3>Other Important Notes</h3>
        <ul>
          <li>The lungs themselves will lose about 12% capacity from age of 30 to 50, and will continue declining even faster as we get older.</li>
          <li>Moderate exercise like walking or cycling has been shown to boost lung size by up to 15%.</li>
          <li>The optimum amount of air we should take in at rest per minute is 5.5 liters.</li>
          <li>The optimum breathing rate is about 5.5 breaths per minute (5.5 second inhales and exhales).</li>
          <li>Central chemoreceptors monitor and send alarm signals to the brain telling our lungs to breath faster and more deeply.  Chemoreceptors direct the body to breath more slowly and to increase carbon dioxide levels (note not oxygen).</li>
        </ul>
        <h3>Other Key Books Referenced</h3>
        <ul>
          <li>The Eye of Revelation: Published by Peter Kelder 1939 about techniques of stretching and breathing that helped reverse his aging.</li>
        </ul>
    </div> 

    <div className="list-container-long">
        <div className="list-section">
          <img src="/images/Hownottoage.png" alt="HowNotToAge Cover" className="list-image" />
          <div className="text-content">
            <h3>How Not To Age: The Scientific Approach to Getting Healthier as You Get Older</h3>
            <p>by Michael Greger, MD | Dec 5, 2023</p>
          </div>
        </div>
      </div>

      <div className="section">
        <p>
          The following are key research notes taken while reading How Not To Age. This is listed for reference as information
          that was extracted during the process.
        </p>
        <h3>Coming Soon!</h3>
        {/* <h3>Vitality Notes</h3>
        <ul>
          <li>AMPK: Enzyme that regulates energy balance and is activated during caloric restriction and exercise.</li>
          <li>mTOR: Key regulator of cell growth and aging; inhibition is associated with longevity.</li>
          <li>
            NAD (Nicotinamide Adenine Dinucleotide): Essential molecule in cellular energy production and DNA repair;
            levels decline with age.
          </li>
          <li>
            Sirtuins (SIRT1 to SIRT7): Family of proteins that regulate cellular health, DNA repair, and metabolism.
            Activated by NAD+ and play a role in longevity.
          </li>
        </ul>
        <h3>Longevity Molecules Notes</h3>
        <ul>
          <li>Rapamycin: mTOR inhibitor known for its anti-aging effects.</li>
          <li>
            Metformin: Common diabetes drug with potential anti-aging benefits. Standard dose often 850 mg; further
            research suggested to understand effects on aging.
          </li>
          <li>
            Resveratrol: Antioxidant found in red wine; known for activating sirtuins but limited by poor solubility.
          </li>
          <li>
            NAD+ Precursors: NR (Nicotinamide Riboside) and NMN (Nicotinamide Mononucleotide): NMN is found in foods like
            avocado, broccoli, and cabbage; David Sinclair's data suggests NMN may protect DNA and improve cellular health.
          </li>
        </ul> */}
      </div> 
  </div>
  );
};

export default Research;
